import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/seasonal-luggage-storage-solutions.jpg'),
    alt: 'seasonal luggage storage solutions page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'seasonal luggage storage solutions page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Seasonal <span>Luggage</span><span>Storage Solutions Available</span>',
  description:
    'Looking for a hassle-free way to store your luggage during seasonal changes? ShipAndStorage offers seasonal luggage storage solutions with secure, climate-controlled facilities, convenient pickup and delivery, and flexible storage plans.',
  image: {
    url: '/images/v2/pages/landing-pages/seasonal-luggage-storage-solutions/hero-image.jpg',
    alt: 'Seasonal Luggage Storage Solutions Available'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register Today' }
}

export const ourProcessSectionContent = {
  title: 'Secure Seasonal Luggage Storage Solutions',

  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Book Your Storage Now' },

  image: {
    url: '/images/v2/pages/landing-pages/seasonal-luggage-storage-solutions/secure-seasonal-luggage-storage-solutions.png',
    alt: 'Secure Seasonal Luggage Storage Solutions'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Booking & Pickup',
      description:
        'Schedule your storage online, and our team will collect your luggage directly from your home, hotel, or office.',
      image: {
        src: '/images/v2/pages/common/easy-booking-tracking.png',
        alt: 'Easy Booking & Pickup'
      }
    },
    {
      id: 2,
      title: 'Climate-Controlled Storage',
      description:
        'Your belongings are stored in secure, climate-controlled facilities to protect against damage and theft.',
      image: {
        src: '/images/v2/pages/common/secure-packaging-labeling.png',
        alt: 'Climate-Controlled Storage'
      }
    },
    {
      id: 3,
      title: 'Convenient Delivery & Retrieval',
      description:
        'When you need your luggage back, simply request delivery, and we’ll bring it to your desired location.',
      image: {
        src: '/images/v2/pages/common/fast-and-reliable-delivery.png',
        alt: 'Convenient Delivery & Retrieval'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Seasonal Luggage Storage Services',
  description:
    'At ShipAndStorage, we provide seasonal luggage storage solutions at competitive rates with no hidden costs. Whether you need storage for a few weeks or several months, our flexible plans allow you to store your luggage affordably. We cater to travelers, students, business professionals, and vacation homeowners looking for a secure and budget-friendly storage option.',
  image: {
    src: '/images/v2/pages/landing-pages/seasonal-luggage-storage-solutions/affordable-seasonal-luggage-storage-services.jpg',
    alt: 'Affordable Seasonal Luggage Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Our Storage Facilities',

  cards: [
    {
      id: 1,
      title: 'Climate-Controlled Storage',
      description:
        'Your luggage is stored in a temperature-controlled environment, protecting it from heat, humidity, and dust to maintain its condition.',
      image: {
        src: '/images/v2/pages/common/climate-controlled-storage2.png',
        alt: 'Climate-Controlled Storage'
      }
    },
    {
      id: 2,
      title: '24/7 Security & Monitoring',
      description:
        'Our facilities are equipped with advanced security systems, including surveillance cameras and restricted access, to ensure your belongings are safe at all times.',
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: '24/7 Security & Monitoring'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Durations',
      description:
        'We offer short-term and long-term storage options, allowing you to store your luggage for as long as you need, whether it’s for a few weeks, months, or an entire season.',
      image: {
        src: '/images/v2/pages/common/flexible-storage-durations.png',
        alt: 'Flexible Storage Durations'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for Seasonal Luggage Storage Solutions?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Frequent Travelers',
          description: 'Store your luggage safely between travels instead of carrying heavy bags.'
        },
        {
          id: 2,
          title: 'Students on Breaks',
          description:
            'Ideal for college students who need a place to store their belongings during summer or winter breaks.'
        },
        {
          id: 3,
          title: 'Business Professionals',
          description:
            "If you're relocating for a short-term assignment, we provide a secure place for your extra luggage."
        },
        {
          id: 4,
          title: 'Vacation Homeowners',
          description: 'Keep your off-season items in storage instead of cluttering your vacation property.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/seasonal-luggage-storage-solutions/who-should-choose-us-for-seasonal-luggage-storage-solutions.jpg',
        alt: 'Who Should Choose Us for Seasonal Luggage Storage Solutions?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Residential Storage',
      description:
        'Need to store extra household items? Our residential storage solutions keep your belongings safe while you renovate, move, or downsize.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Residential Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Moving Storage',
      description:
        'We provide temporary storage solutions for those in the middle of a move, ensuring your items are safe and accessible when needed.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage',
      description:
        'Businesses can store important documents, seasonal inventory, or office equipment in our secure facilities with flexible access options.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'College Storage',
      description:
        'Students can store their belongings during academic breaks with our convenient and affordable college storage plans.',
      image: {
        src: '/images/v2/pages/common/student-storage-options.png',
        alt: 'College Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Seasonal Luggage Storage Solutions?',

  image: {
    url: '/images/v2/pages/landing-pages/seasonal-luggage-storage-solutions/why-choose-us-for-seasonal-luggage-storage-solutions.jpg',
    alt: 'Why Choose Us for Seasonal Luggage Storage Solutions?'
  },

  articles: [
    {
      id: 1,
      title: 'Affordable Pricing',
      description: 'Our budget-friendly storage plans help you save on luggage storage costs.'
    },
    {
      id: 2,
      title: 'Flexible Terms',
      description: 'Store your luggage for short periods or for an entire season, as needed.'
    },
    {
      id: 3,
      title: 'Secure Facilities',
      description: 'Climate-controlled storage units ensure your belongings are always protected.'
    },
    {
      id: 4,
      title: 'Nationwide Access',
      description: 'Our services are offered in multiple locations for easy storage retrieval.'
    },
    {
      id: 5,
      title: 'Hassle-Free Service',
      description: 'We provide pickup and delivery for a convenient storage experience.'
    },
    {
      id: 6,
      title: 'Simple Online Booking ',
      description: 'Our platform allows easy booking, management, and tracking of your storage'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Seasonal Luggage Storage Solutions Secure And Affordable',
  description:
    'Seasonal luggage storage solutions fast and affordable. Secure options for storing your luggage during off-seasons or between trips.',
  image: {
    src: '/images/v2/pages/landing-pages/seasonal-luggage-storage-solutions/seasonal-luggage-storage-solutions-secure-and-affordable.png',
    alt: 'Seasonal Luggage Storage Solutions Secure And Affordable'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Reserve Your Spot' }
}

export const ourPartnersSectionContent = {
  title: 'Trusted Shipping Partners',
  description:
    'We collaborate with leading shipping providers to ensure secure, reliable, and efficient transportation for your storage and shipping needs.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx offers dependable shipping solutions, ensuring your office equipment is delivered safely and on time.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For the latest details, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL specializes in international shipping, providing seamless storage and retrieval solutions for your office equipment worldwide.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For up-to-date details, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS ensures the safe and reliable transportation of your stored office equipment, offering a smooth and hassle-free shipping experience.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For the latest details, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
